import { TableHeadersType } from "../../tableHeadersType";

export const RECEIPT_AND_PAYMENT_HEADERS: TableHeadersType[] = [
  {
    label: 'ACCOUNT NAME',
    value: 'account_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'AMOUNT',
    value: 'amount',
    checked: true,
    defaultChecked: true
  }
]

